import { BaseQuery, DitaInputUpdate } from 'generated/graphql';
import { mapBaseQueryFields } from './BaseQueryInputUpdateMapper';

export const mapToDitaInputUpdate = (q: BaseQuery, assignee?: string): DitaInputUpdate => {
  return {
    ...mapBaseQueryFields(q, assignee),
    fileName: q.queryDetails?.__typename === 'DitaQuery' ? q.queryDetails?.fileName : '',
    xtmProjectName:
      q.queryDetails?.__typename === 'DitaQuery' ? q.queryDetails?.xtmProjectName : '',
    cmsProject: q.queryDetails?.__typename === 'DitaQuery' ? q.queryDetails?.cmsProject : '',
    loio: q.queryDetails?.__typename === 'DitaQuery' ? q.queryDetails?.loio : '',
    deliverable: q.queryDetails?.__typename === 'DitaQuery' ? q.queryDetails?.deliverable : '',
    fileTitle: q.queryDetails?.__typename === 'DitaQuery' ? q.queryDetails?.fileTitle : '',
    submap: q.queryDetails?.__typename === 'DitaQuery' ? q.queryDetails?.submap : '',
    sourceContact: q.queryDetails?.__typename === 'DitaQuery' ? q.queryDetails?.sourceContact : ''
  };
};
